$(document).ready(function () {
    $('.copy-btn').click(function () {
        const $button = $(this);
        const textToCopy = $button.data('content');
        navigator.clipboard.writeText(textToCopy).then(() => {
            $button.addClass('copy-success');
            setTimeout(() => {
                $button.removeClass('copy-success');
            }, 2000);
        }, function (err) {
            console.error('Could not copy text: ', err);
        });
    });
});
